/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityFindingNativeDetailsForDockle extends models.SecurityFindingNativeDetailsBaseForContainer {
    constructor() {
        super();
        this.setDiscriminator("SecurityFindingNativeDetailsForDockle");
    }

    getFixupPrototypeFunction() { return SecurityFindingNativeDetailsForDockle.fixupPrototype; }

    static newInstance(model: Partial<SecurityFindingNativeDetailsForDockle>): SecurityFindingNativeDetailsForDockle {
        let obj = Object.assign(new SecurityFindingNativeDetailsForDockle(), model);
        SecurityFindingNativeDetailsForDockle.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityFindingNativeDetailsForDockle>): SecurityFindingNativeDetailsForDockle {
        if (!model) return null;
        return SecurityFindingNativeDetailsForDockle.newInstance(<SecurityFindingNativeDetailsForDockle> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityFindingNativeDetailsForDockle) {
        if (!obj) return;

        models.SecurityFindingNativeDetailsForDockle.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityFindingNativeDetailsForDockle): boolean {
        if (models.SecurityFindingNativeDetailsBaseForContainer.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SecurityFindingNativeDetailsForDockle.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.source_data) {
            models.SecurityFindingSourceDetailsForDockle.fixupPrototype(this.source_data);
        }
    }

    /**
     * Full name and tag of the container image that was analyzed by Dockle for security vulnerabilities
     */
    image: string;

    /**
     * Specific alert message from Dockle that represents this individual finding
     */
    alert: string;

    /**
     * Complete original data from Dockle containing detailed finding information and scan results
     */
    source_data: models.SecurityFindingSourceDetailsForDockle;

}
